import React from 'react';
import { FadeUp } from '../components/AnimatedSection';
import { useLanguage } from '../context/LanguageContext';

const ReturnsPage = () => {
  const { language, t } = useLanguage();

  const contentEn = (
    <div className="space-y-8 max-w-3xl">
      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">30-Day Return Policy</h2>
        <p className="text-[#86868B] leading-relaxed">
          We have a 30-day return policy, which means you have 30 days after receiving your item to request a return. 
          The item must be in the same condition that you received it, unworn, with tags, and in its original packaging, 
          for a return to be accepted. You will also need the receipt or proof of purchase.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">How to Initiate a Return</h2>
        <p className="text-[#86868B] leading-relaxed">
          To initiate a return, please contact us at contact.tivorao@gmail.com. If the return is accepted, 
          we will send you a return shipping label along with instructions on how and where to send your package. 
          Items returned without prior request will not be accepted.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Damages and Issues</h2>
        <p className="text-[#86868B] leading-relaxed">
          Please inspect your order upon receipt and contact us immediately if the item is defective, damaged, 
          or if you receive the wrong item, so that we can evaluate the issue and resolve it.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Exceptions / Non-returnable Items</h2>
        <p className="text-[#86868B] leading-relaxed">
          Unfortunately, we cannot accept returns on sale items or gift cards.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">European Union 14-Day Cooling-Off Period</h2>
        <p className="text-[#86868B] leading-relaxed">
          If goods are shipped to the European Union, you have the right to cancel or return your order 
          within 14 days, for any reason and without justification. The item must be in the same condition 
          as you received it, unworn, with tags, and in its original packaging.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Refunds</h2>
        <p className="text-[#86868B] leading-relaxed">
          We will notify you once we have received and inspected your return, and let you know if the refund 
          has been approved or not. If approved, you will be automatically refunded to your original payment 
          method within 10 business days. Please remember that it may take some time for your bank or credit 
          card company to process and post the refund. If more than 15 business days have passed since we 
          approved your return, please contact us at contact.tivorao@gmail.com.
        </p>
      </section>
    </div>
  );

  const contentEs = (
    <div className="space-y-8 max-w-3xl">
      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Política de devolución de 30 días</h2>
        <p className="text-[#86868B] leading-relaxed">
          Tenemos una política de devolución de 30 días, es decir, dispones de 30 días después de recibir 
          el artículo para solicitar una devolución. El artículo debe estar en el mismo estado en que lo 
          recibiste, sin usar, con las etiquetas y en su embalaje original, para que se admita su devolución. 
          También necesitarás el recibo o comprobante de compra.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Cómo iniciar una devolución</h2>
        <p className="text-[#86868B] leading-relaxed">
          Para iniciar una devolución, puedes ponerte en contacto con nosotros a la dirección contact.tivorao@gmail.com. 
          Si se acepta la devolución, te enviaremos una etiqueta de envío para la devolución junto con las instrucciones 
          sobre cómo y dónde enviar el paquete. No se aceptarán artículos devueltos sin haber solicitado previamente la devolución.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Daños y problemas</h2>
        <p className="text-[#86868B] leading-relaxed">
          Por favor, revisa tu pedido en cuanto lo recibas y ponte en contacto con nosotros de inmediato si el 
          artículo está defectuoso, dañado o si recibes un artículo equivocado, para que podamos evaluar el 
          problema y solucionarlo.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Excepciones / artículos sin devolución</h2>
        <p className="text-[#86868B] leading-relaxed">
          Desafortunadamente, no podemos aceptar devoluciones de artículos en oferta o tarjetas de regalo.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Periodo de reflexión de 14 días de la Unión Europea</h2>
        <p className="text-[#86868B] leading-relaxed">
          Si la mercancía se envía dentro de la Unión Europea, tienes derecho a anular o devolver tu pedido 
          en un plazo de 14 días, por cualquier motivo y sin necesidad de justificación. El artículo debe 
          estar en las mismas condiciones en que lo recibiste, sin usar, con las etiquetas y en su embalaje original.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Reembolsos</h2>
        <p className="text-[#86868B] leading-relaxed">
          Te informaremos cuando hayamos recibido e inspeccionado tu devolución y te comunicaremos si se ha 
          aprobado el reembolso o no. Si se aprueba, se te reembolsará de forma automática en tu forma de pago 
          original en un plazo de 10 días hábiles. Recuerda que el banco o la entidad emisora de la tarjeta de 
          crédito pueden tardar algún tiempo en procesar y hacer efectivo el reembolso. Si han transcurrido más 
          de 15 días hábiles desde que aprobamos tu devolución, ponte en contacto con nosotros a la dirección 
          contact.tivorao@gmail.com.
        </p>
      </section>
    </div>
  );

  return (
    <div data-testid="returns-page" className="min-h-screen bg-black">
      <div className="container-apple section-content pt-32">
        <FadeUp>
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight mb-4">
            {t('legal.returnsTitle')}
          </h1>
          <p className="text-[#86868B] mb-12">{t('legal.lastUpdated')}: December 2025</p>
          {language === 'es' ? contentEs : contentEn}
        </FadeUp>
      </div>
    </div>
  );
};

export default ReturnsPage;
